import {
  ButtonBar,
  type ButtonBarItem,
  ErrorBox,
  NetworkSelect,
  Spinner,
} from "@gearbox-protocol/deploy-tools-ui";
import {
  CreditSuiteSelector,
  CuratorSelector,
  MarketSelector,
  SDKView,
} from "components/sdk-state";
import type { FC } from "react";
import { useEffectOnce } from "react-use";
import { useShallow } from "zustand/react/shallow";
import { LIVE_NETWORKS } from "../../constants";
import { useSDKStore } from "./store";

const formatNav: ButtonBarItem<"yaml" | "json">[] = [
  {
    id: "yaml",
    title: "YAML (state human)",
  },
  {
    id: "json",
    title: "JSON (raw state)",
  },
];

const SDKRoute: FC = () => {
  const state = useSDKStore(
    useShallow(s => ({
      network: s.networkType,
      language: s.language,
      setNetwork: s.setNetworkType,
      setLanguage: s.setLanguage,
      loading: s.loading,
      error: s.error,
      fromCache: s.fromCache,
      sdk: s.sdk,
      curator: s.curator,
      market: s.market,
      creditManager: s.creditManager,
      setCurator: s.setCurator,
      setMarket: s.setMarket,
      setCreditManager: s.setCreditManager,
    })),
  );
  useEffectOnce(() => {
    console.log("setting network to Mainnet");
    state.setNetwork("Mainnet");
  });

  return (
    <div className="flex flex-row items-start gap-x-4">
      <div className="w-96 flex flex-col rounded-xl bg-background gap-y-2 mt-4 p-4 min-h-96">
        <ButtonBar<"yaml" | "json">
          items={formatNav}
          activeId={state.language}
          onChange={state.setLanguage}
          buttonClassName="py-1! bg-white/10 hover:bg-black/10 has-checked:bg-black/20"
        />
        <NetworkSelect
          value={state.network}
          onChange={state.setNetwork}
          includeNetworks={LIVE_NETWORKS}
        />
        {!!state.sdk && (
          <>
            <CuratorSelector
              sdk={state.sdk}
              value={state.curator}
              onChange={state.setCurator}
            />
            <MarketSelector
              sdk={state.sdk}
              curator={state.curator}
              value={state.market}
              onChange={state.setMarket}
            />
            <CreditSuiteSelector
              sdk={state.sdk}
              market={state.market}
              value={state.creditManager}
              onChange={state.setCreditManager}
            />
          </>
        )}
        <div className="flex-1" />

        <div className="text-sm text-foreground self-end justify-self-end">
          *loaded from cache
        </div>
      </div>
      <div className="flex-1 flex flex-col rounded-xl bg-background gap-y-2 mt-4 p-4 min-h-full overflow-x-hidden">
        {!!state.loading && (
          <div className="flex-1 flex items-center justify-center">
            <Spinner />
          </div>
        )}
        {!!state.error && (
          <div className="flex-1">
            <ErrorBox error={state.error} />
          </div>
        )}
        <SDKView
          sdk={state.sdk}
          language={state.language}
          curator={state.curator}
          market={state.market}
          creditManager={state.creditManager}
        />
      </div>
    </div>
  );
};

export default SDKRoute;
